import { BlocksIconNewspaper } from 'blocks-nextjs/blocks-web-components/components/icon/icons/newspaper';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconNewspaper = createComponent({ react: React, tagName: 'cat-icon-newspaper', elementClass: BlocksIconNewspaper });
